console.log("retrocomp-para-depliable.js");

function creerBlocDetails() {
    const titresDepliables = document.querySelectorAll("h3.titre_depliable");

    titresDepliables.forEach((titre, index) => {
        const contenu = titre.nextElementSibling;

        // Ne traiter que le couple h3 + div.contenu_deplie
        if (
            contenu &&
            contenu.tagName === "DIV" &&
            contenu.classList.contains("contenu_deplie")
        ) {
            const details = document.createElement("details");
            details.classList.add("accordion", "accordion--retro");

            if (index === 0) {
                details.setAttribute("open", "");
            }

            const summary = document.createElement("summary");
            summary.textContent = titre.textContent;

            const contenuDeplieDiv = document.createElement("div");
            contenuDeplieDiv.className = "accordion__content";
            contenuDeplieDiv.appendChild(contenu.cloneNode(true));

            details.appendChild(summary);
            details.appendChild(contenuDeplieDiv);

            titre.parentNode.insertBefore(details, titre);

            titre.remove();
            contenu.remove();
        }
    });
}

function entourerTitreAvecSummary() {
    document
        .querySelectorAll("details.accordion--retro > summary")
        .forEach((summary) => {

            const titleText = summary.textContent;
            summary.innerHTML = "";

            // bouton ouverture
            const iconOpen = document.createElement("span");
            iconOpen.className = "accordion__icon accordion__icon--open";
            iconOpen.setAttribute("aria-label", "Ouvrir le bloc");

            iconOpen.innerHTML = `
                <svg role="img" xmlns="http://www.w3.org/2000/svg" class="icon icon-plus">                
                <use href="/static/icons/uga.svg#icon-plus" aria-hidden="true"></use>
              </svg>
            `;

            // bouton fermeture
            const iconClose = document.createElement("span");
            iconClose.className = "accordion__icon accordion__icon--close";
            iconClose.setAttribute("aria-label", "Fermer le bloc");

            iconClose.innerHTML = `
                <svg role="img" xmlns="http://www.w3.org/2000/svg" class="icon icon-minus">                
                <use href="/static/icons/uga.svg#icon-minus" aria-hidden="true"></use>
              </svg>
            `;

            // titre
            const title = document.createElement("span");
            title.className = "accordion__title";
            title.textContent = titleText;

            summary.appendChild(iconOpen);
            summary.appendChild(iconClose);
            summary.appendChild(title);
        });
}

// ouverture clavier
function retrocompOuvrirBoutonIcon() {
    const boutons = document.querySelectorAll(
        ".accordion--retro .accordion__icon--open"
    );

    boutons.forEach((bouton) => {
        bouton.addEventListener("keydown", function (event) {
            if (event.key === "Enter" || event.key === " ") {
                const details = bouton.closest("details");
                if (details) {
                    details.setAttribute("open", "");
                }
            }
        });
    });
}

// fermeture clavier
function retrocompFermerBoutonIcon() {
    const boutons = document.querySelectorAll(
        ".accordion--retro .accordion__icon--close"
    );

    boutons.forEach((bouton) => {
        bouton.addEventListener("keydown", function (event) {
            if (event.key === "Enter" || event.key === " ") {
                const details = bouton.closest("details");
                if (details) {
                    details.removeAttribute("open");
                }
            }
        });
    });
}

document.addEventListener("DOMContentLoaded", function () {
    creerBlocDetails();
    entourerTitreAvecSummary();
    retrocompOuvrirBoutonIcon();
    retrocompFermerBoutonIcon();
});